
// app.component.ts

import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SocketService } from './core/services/socket.service';
import { AuthService } from './core/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private socketService: SocketService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    // Connect socket if user is logged in
    const user = this.authService.getCurrentUser();
    if (user) {
      this.socketService.connect();

      // Listen for notifications
      this.socketService.onNotification(() => {
        // La campanita (topbar) escuchará y recargará. No mostramos Toast intrusivo.
      });
    }
  }

}

